<template>
  <div class="open-tools" :class="{ light: theme === 'light' }">
    <el-dropdown v-if="showDropdown" trigger="click" @command="handleCommand">
      <span class="trigger-text">
        <i class="el-icon-s-tools"></i>
        功能菜单
        <el-badge
          v-if="notReadMessageCount"
          class="chatroom-tip"
          :value="notReadMessageCount"
          :max="99"
        >
          对话
        </el-badge>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="iconfont icon-chatroom" command="chatroom">
          <el-badge
            :value="notReadMessageCount"
            :max="99"
            :hidden="!notReadMessageCount"
          >
            开标对话
          </el-badge>
        </el-dropdown-item>
        <el-dropdown-item icon="el-icon-edit-outline" command="controlPrice">
          设置控制价
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <bid-chatroom
      ref="chatroom"
      :style="{ display: showDropdown ? 'none' : '' }"
      :project-id="projectId"
      :project-status="projectStatus"
      :theme="theme"
      :supplier-list="supplierList"
      :order-status="orderStatus"
      @getNotReadMessageCount="count => (notReadMessageCount = count)"
    />

    <kpb-open-control-price-dialog
      ref="controlPrice"
      :offer-unit="offerUnit"
      :project-id="projectId"
      :control-price-config="controlPriceConfig"
      @reload="() => $emit('reload')"
    />
  </div>
</template>

<script>
import BidChatroom from '@/components/kpb/open/BidChatroom.vue'
import KpbOpenControlPriceDialog from '@/components/kpb/open/KpbOpenControlPriceDialog.vue'

export default {
  name: 'KpbOpenTools',

  components: { BidChatroom, KpbOpenControlPriceDialog },

  props: {
    theme: {
      validator: function(value) {
        return ['dark', 'light'].indexOf(value) !== -1
      },
      default: 'dark'
    },

    projectId: {
      type: [String, Number],
      default: ''
    },

    // 投标id，供应商开标大厅使用
    bidderId: {
      type: [String, Number],
      default: ''
    },

    projectStatus: {
      type: [String, Number],
      default: ''
    },

    // 供应商列表
    supplierList: {
      type: Array,
      default: () => []
    },

    // 采购人（公告发布者）
    purchaserInfo: {
      type: Object,
      default: () => {}
    },

    // 报价单位
    offerUnit: {
      type: String,
      default: ''
    },

    // 控制价信息
    controlPriceConfig: {
      type: Object,
      default: () => {}
    },

    showDropdown: {
      type: Boolean,
      default: false
    },

    orderStatus: {
      type: [String, Number],
      default: ''
    },
  },

  data() {
    return {
      notReadMessageCount: 0
    }
  },

  methods: {
    handleCommand(command) {
      if (command === 'chatroom') {
        this.$refs.chatroom.visible = true
        return
      }
      if (command === 'controlPrice') {
        this.$refs.controlPrice.visible = true
        return
      }
    }
  }
}
</script>

<style scoped lang="scss">
.open-tools {
  display: inline-block;

  .trigger-text {
    color: $white-color;
    font-size: 20px;
    cursor: pointer;

    ::v-deep .el-badge__content.is-fixed {
      top: -6px;
      right: 0px;
    }
  }

  .chatroom-tip {
    font-size: 14px;
    color: $info-fifth-color;
  }

  &.light {
    .trigger-text {
      color: $text-color;
    }

    .chatroom-tip {
      color: $second-text-color;
    }
  }
}
</style>
